import React, { useEffect, useRef, useCallback } from "react";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";

// //Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import withRouter from "components/Common/withRouter";
import { Link } from "react-router-dom";

// Custom hooks
import { useUserGroups } from "../../shared/hooks/useUserGroups";

//i18n
import { withTranslation } from "react-i18next";

const closeMobileMenu = () => {
  // Below lg the sidebar is an overlay toggled via body.sidebar-enable; tapping
  // a link must dismiss it, otherwise the page changes behind the menu.
  if (window.matchMedia && window.matchMedia("(max-width: 991.98px)").matches) {
    document.body.classList.remove("sidebar-enable");
  }
};

const SidebarContent = props => {
  const ref = useRef();
  const location = useLocation();
  const { isAssociate, isAdmin } = useUserGroups();
  

  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };

  const activeMenu = useCallback(() => {
    const pathName = location.pathname;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [location.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu("#side-menu");
    activeMenu();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    activeMenu();
  }, [activeMenu]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Minha área")}</li>

            {/* <li className="menu-title">{props.t("Apps")}</li> */}

            <li>
              <Link to="/profile" onClick={closeMobileMenu}>
                <i className="bx bx-user"></i>
                <span>{props.t("Profile")}</span>
              </Link>
            </li>
            
            {!isAssociate && !isAdmin && (
              <li>
                <Link to="/curriculum" onClick={closeMobileMenu}>
                  <i className="bx bx-file"></i>
                  <span>{props.t("Curriculum")}</span>
                </Link>
              </li>
            )}

            {(isAssociate || isAdmin) && (
              <>
                <li className="menu-title">{props.t("Associado")}</li>
                <li>
                  <Link to="/candidatos" onClick={closeMobileMenu}>
                    <i className="bx bx-group"></i>
                    <span>{props.t("Candidatos")}</span>
                  </Link>
                </li>
              </>
            )}

            {isAdmin && (
              <>
                <li className="menu-title">{props.t("Administração")}</li>
                <li>
                  <Link to="/admin/dashboard" onClick={closeMobileMenu}>
                    <i className="bx bx-bar-chart-alt-2"></i>
                    <span>{props.t("Painel")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/admin/users" onClick={closeMobileMenu}>
                    <i className="bx bx-shield-quarter"></i>
                    <span>{props.t("Usuários")}</span>
                  </Link>
                </li>
              </>
            )}
            
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
